module.exports = __webpack_public_path__ + "img/img_tool_2.33cd858b.jpg";